(() => {
  const ROOT_SELECTOR = '[data-brand-collection-search-root]';
  const CARD_SELECTOR = '#product-grid [data-brand-product-card]';
  const HIDDEN_CLASS = 'brand-card-hidden';
  const DESCRIPTION_ROOT_SELECTOR = '[data-brand-description-root]';

  const normalize = (value) => (value || '').toString().toLowerCase().trim();

  const applyFilter = (root) => {
    if (!root) return;

    const input = root.querySelector('[data-brand-quick-search-input]');
    const inStockToggle = root.querySelector('[data-brand-instock-toggle]');
    const status = root.querySelector('[data-brand-quick-search-status]');
    const cards = Array.from(document.querySelectorAll(CARD_SELECTOR));

    if (!input || !inStockToggle || !status || cards.length === 0) return;

    const keyword = normalize(input.value);
    const inStockOnly = inStockToggle.checked;
    let visibleCount = 0;

    cards.forEach((card) => {
      const haystack = normalize(card.dataset.searchText);
      const isAvailable = card.dataset.available === 'true';
      const keywordMatch = keyword === '' || haystack.includes(keyword);
      const stockMatch = !inStockOnly || isAvailable;
      const isVisible = keywordMatch && stockMatch;
      card.classList.toggle(HIDDEN_CLASS, !isVisible);
      card.toggleAttribute('hidden', !isVisible);
      if (isVisible) visibleCount += 1;
    });

    const nextStatus = `${visibleCount}件を表示中`;
    if (status.textContent !== nextStatus) {
      status.textContent = nextStatus;
    }
  };

  const init = (root) => {
    if (!root || root.dataset.brandQuickSearchReady === 'true') return;

    const input = root.querySelector('[data-brand-quick-search-input]');
    const inStockToggle = root.querySelector('[data-brand-instock-toggle]');
    const clearButton = root.querySelector('[data-brand-quick-search-clear]');

    if (!input || !inStockToggle || !clearButton) return;

    const trigger = () => applyFilter(root);
    input.addEventListener('input', trigger);
    inStockToggle.addEventListener('change', trigger);
    clearButton.addEventListener('click', () => {
      input.value = '';
      inStockToggle.checked = false;
      input.focus();
      trigger();
    });

    const gridContainer = document.getElementById('ProductGridContainer');
    if (gridContainer) {
      const observer = new MutationObserver((mutations) => {
        const shouldRefresh = mutations.some((mutation) => {
          const target = mutation.target;
          if (target instanceof Element && target.closest('#product-grid')) return true;

          const nodes = [...mutation.addedNodes, ...mutation.removedNodes];
          return nodes.some((node) => {
            if (!(node instanceof Element)) return false;
            if (node.id === 'product-grid') return true;
            if (node.matches('[data-brand-product-card]')) return true;
            return node.querySelector('[data-brand-product-card]') !== null;
          });
        });

        if (shouldRefresh) trigger();
      });
      observer.observe(gridContainer, { childList: true, subtree: true });
    }

    root.dataset.brandQuickSearchReady = 'true';
    trigger();
  };

  const boot = () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => init(root));
    document.querySelectorAll(DESCRIPTION_ROOT_SELECTOR).forEach((root) => {
      if (!root || root.dataset.brandDescriptionReady === 'true') return;
      const toggle = root.querySelector('[data-brand-description-toggle]');
      const content = root.querySelector('.brand-description-collapsible__content');
      if (!toggle) return;
      if (!content) return;

      root.classList.remove('is-expanded');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = '続きを読む';

      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        const nextExpanded = !expanded;
        root.classList.toggle('is-expanded', nextExpanded);
        toggle.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
        toggle.textContent = nextExpanded ? '閉じる' : '続きを読む';
      });

      root.dataset.brandDescriptionReady = 'true';
    });
  };

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:reorder', boot);
  document.addEventListener('shopify:section:select', boot);
})();
